import React from 'react';
import styled from 'styled-components';
import Guide from '../../../../dev/Guide'

const changeNumberToMilionAndKilo = (e) => {
    return e.map(e => {
        if (e >= 1000000) {
            return (e / 1000000).toFixed(1) + 'M'
        }
        if(e >=1000) {
            return (e / 1000).toFixed(1)+'K'
        }
        return e
    })
}
const changeNumberToDecimal = (e) => {
    return e.map(e => {
        if (isNaN(e) === false && e>0) {
            return e+'%';
        }
        return e
    })
}
const SpanWithChangeNumber = (e) => {
    const { max } = e
    if(max <=100) {
        return (
            <span {...e}>
                {changeNumberToDecimal(e.children)}
            </span>
        )
    }
    return (
        <span {...e}>
            {changeNumberToMilionAndKilo(e.children)}
        </span>
    )
}
const SliderTitle = (props) => {
    const { sliderTitle, range, max, sliderTitleDesc } = props
    return (
        <SliderTitleWrap>
            <SpanWithChangeNumber max={max}>{sliderTitle} : {range[0]} - {range[1]}</SpanWithChangeNumber>
            <Guide list={sliderTitleDesc}/>
        </SliderTitleWrap>
    )
}
export default SliderTitle;

const SliderTitleWrap = styled.div`
    display: flex;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: #787878;
    height: 100%;
`


// WEBPACK FOOTER //
// ./src/InfoList/Search/dev/SliderBarSearch/SliderTitle.js